import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, ViewChildren } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { DatePipe } from '@angular/common';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { AddpaymodepopupComponent } from '../../generalpopup/addpaymodepopup/addpaymodepopup.component';
import { AddtranspaymodepopupComponent } from '../../generalpopup/addtranspaymodepopup/addtranspaymodepopup.component';
@Component({
  selector: 'app-transpaymentinfo',
  templateUrl: './transpaymentinfo.component.html',
  styleUrls: ['./transpaymentinfo.component.css']
})
export class TranspaymentinfoComponent implements OnInit {

  dateCustomClasses: DatepickerDateCustomClasses[];
  constructor(private toastr: ToastrService, private appService: AppdataService,
    public loginService: LoginserviceService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService,
    private datePipe: DatePipe,private productFindService: NgbModal) {
      this.dateCustomClasses = [
        { date: new Date(), classes: ['bg-warning'] },
      ];
     }

   
  //Save Validation
  submitted: boolean;
  successfully: boolean;
 
  isduplicate: boolean;

  

  transpaymentinfoform = new FormGroup({
   
    transpaymodeid: new FormControl(null, Validators.required),
    refno: new FormControl(null),
    paiddt: new FormControl('', Validators.required),
   paymentinfo: new FormControl(''),
    
  });

  transpaymodeColl: any = [];

  
  @Input() trid:any=0;
  @Input() transpaymodeid: any = null;
  @Input() refno: any = null;
  @Input() paiddt: any=null;
  @Input() paymentinfo: any = null;
  @Input() formname: any = '';
  @Input() transdate: any = null;
  
  @Output() emitData = new EventEmitter();

  ngOnInit() {

    this.transpaymentinfoform.reset();
    this.fnInitializeFormGroup();
    this.fngetTranspaymode();
   
  }


  fnInitializeFormGroup() {
    this.transpaymentinfoform.setValue({
      transpaymodeid: this.transpaymodeid,
      refno: this.refno,
      paiddt: this.paiddt,      
      paymentinfo: this.paymentinfo,
    
    })
  }
  fngetTranspaymode() {
    var data = {
      'transpaymodeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'filterstatus': ""
    }
    this.appService.getTransPaymode(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.transpaymodeColl = res.json().result;

          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  
  fnResetValidation() {
    if (this.loginService.fnCheckFornControlNotfound(this.transpaymentinfoform.get('paiddt'))) {
      this.transpaymentinfoform.controls['paiddt'].setErrors(null);
    }

  }


  fnSetValidation() {
    let _ischeck = false;
    
    if (this.loginService.fnCompareDateValidation(this.transpaymentinfoform.get('paiddt').value, this.transdate)) {
      this.transpaymentinfoform.controls['paiddt'].setErrors({ 'notfound': true });
      _ischeck = true;
    }

    return _ischeck;
  }


  fnSaveBtnClick() {
    try {
      this.submitted = true;
      this.successfully = false;

      this.fnResetValidation();

      //Validate
      if (this.transpaymentinfoform.valid) {

        if (this.fnSetValidation()) {
          return;
        }

        //Check
        var data = {
          trid:this.trid,
          companyid:this.loginService.fnGetCompanyId(),
          formname:this.formname,
          transpaymodeid: this.transpaymentinfoform.get('transpaymodeid').value,
          refno: this.transpaymentinfoform.get('refno').value,
          paiddt: this.fnFormatDatetime(this.transpaymentinfoform.get('paiddt').value),
          paymentinfo:this.transpaymentinfoform.get('paymentinfo').value,
          modifiedby:this.loginService.fnGetModUserId(),   
        }
      this.appService.fnSetTranspaymentinfo(data).subscribe(
        (res)=>{ 
          if(res.json().status===200){  
            this.emitData.emit('DONE');
            this.activeModal.close(true);
            }
          else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err)=>{ 
          this.toastr.error('Error', err);
        });
      }
    }
     catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

    //AddTransPaymode
    private fnAddTransPaymode() {

      const modalRef = this.productFindService.open(AddtranspaymodepopupComponent, { size: <any>'l' });
  
      modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
  
        this.fngetTranspaymode();
  
        if (receivedEntry > 0) {
          this.transpaymentinfoform.patchValue({ transpaymodeid: receivedEntry })
        }
      });
  
    }
  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }

  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }
  public decline() {
    this.activeModal.close(false);
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }

}
